import { useQuery } from "react-query";
import { getSafeDetailsByRecordNumber } from "../../../../actions/CarrierAgreementMgmt/Security";

export const useGetSafeDetailsByRecordNumber = (recNumber) => {
  return useQuery(
    ["GetSafeDetailsByRecordNumber", recNumber],
    () => getSafeDetailsByRecordNumber(recNumber),
    { refetchOnWindowFocus: false }
  );
};
